/**
 * P1-S4 — age confirmation, once per device.
 *
 * `hc_age_confirmed` holds the ISO timestamp of the confirmation. It is
 * deliberately independent of the PIN lock and of the signed-in account.
 */
export const AGE_CONFIRMED_KEY = 'hc_age_confirmed';

export const DEFAULT_AGE_GATE_EXIT_URL = 'https://www.google.com';

export function hasConfirmedAge(): boolean {
  try {
    return Boolean(window.localStorage.getItem(AGE_CONFIRMED_KEY));
  } catch {
    return false;
  }
}

export function confirmAge(now: Date = new Date()): void {
  try {
    window.localStorage.setItem(AGE_CONFIRMED_KEY, now.toISOString());
  } catch {
    // Storage blocked: the gate shows again next load.
  }
}

/** `VITE_AGE_GATE_EXIT_URL`, accepted only when it is an http(s) URL. */
export function getAgeGateExitUrl(
  configured: string | undefined = import.meta.env.VITE_AGE_GATE_EXIT_URL
): string {
  if (configured) {
    try {
      const url = new URL(configured);
      if (url.protocol === 'https:' || url.protocol === 'http:') {
        return url.toString();
      }
    } catch {
      // Not a URL: fall through to the default.
    }
  }
  return DEFAULT_AGE_GATE_EXIT_URL;
}
